import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { proofSystems } from '@/data/proofRegistry';

export const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    let id;
    try { id = decodeURIComponent(hash.slice(1)); }
    catch (_) { id = hash.slice(1); }
    if (pathname === '/' && proofSystems.some(proof => id === `proof-${proof.id}`)) {
      navigate(`/systems#${id}`, { replace: true }); return;
    }
    const aliases = { author: 'founder', practice: 'engagement', work: 'engagement' };
    const target = pathname === '/' ? aliases[id] || id : id;
    if (!target) { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); return; }
    const frame = requestAnimationFrame(() => {
      document.getElementById(target)?.scrollIntoView({ behavior: 'instant', block: 'start' });
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash, navigate]);
  return null;
};